import { h, Component } from 'preact';
import Helmet from 'preact-helmet';
import { Router } from 'preact-router';
import injectTapEventPlugin from 'preact-tap-event-plugin';


injectTapEventPlugin();


let listData = [
	{
		id: "families",
		title: "Familias",
		description: "",
		items: [
			"Orar por las familia y cada individuo.",
			"Restauración en los hogares y sanidad interior para cada individuo.",
			"Que permanezcan fuertes en la fe."
		]
	},
	{
		id: "next_generation",
		title: "Próxima Generación",
		description: "",
		items: [
			"Niños: Que tengan un encuentro con Jesús a temprana edad y que puedan fluir en los dones que Dios deposite en sus vidas.",
			"Jóvenes: Pasión por Jesús, santidad, valentía y éxito en estudios."
		]
	},
	{
		id: "pastors",
		title: "Pastores y Líderes",
		description: "",
		items: [
			"Familias Pastorales: Protección especial para sus hijos.",
			"Sabiduría de parte de Dios.",
			"Unción.",
			"Protección, salud, y provisión."
		]
	},
	{
		id: "economy",
		title: "Economía",
		description: "",
		items: [
			"Oramos por el equipo Financiero: Gustavo, Héctor y Jeikel.",
			"Que Dios enseñe a cada familia a ser buenos administradores de su economía.",
			"Romper toda maldición de pobreza en las familias de la Iglesia.",
			"Que siempre haya un espíritu generoso y obediente en todos.",
			"Siempre haya recursos económicos en la Iglesia para cada proyecto que Dios ponga en el corazón de los Pastores."
		]
	},
	{
		id: "services",
		title: "Servicios",
		description: "Unción, fortaleza, ánimo y creatividad para los que sirven en:",
		items: [
			"Alabanza",
			"Zona kids",
			"Organización",
			"Departamento técnico",
			"Equipo de Limpieza",
			"Los que buscan recursos económicos para la Iglesia."
		]
	},
	{
		id: "win",
		title: "Ganar",
		description: "",
		items: [
			"Que Dios atraiga el fruto maduro, es decir personas que estén verdaderamente necesitadas de Dios.",
			"Pasión por las almas perdidas.",
			"Orar para que Dios nos ponga metas y desafíos grandes.",
			"Orar por estrategias nuevas para cumplir las metas.",
			"Unción, protección e inspiración para el equipo del departamento del GANAR."
		]
	},
	{
		id: "consolidate",
		title: "Consolidar",
		description: "",
		items: [
			"Que los nuevos convertidos puedan consolidar las decisiones de su nueva vida en Cristo, levantando el escudo de FE sobre sus vidas.",
			"Pasión por los nuevos convertidos.",
			"Que podamos cumplir los propósitos de la Universidad de la vida.",
			"Unción, protección e inspiración para el equipo del departamento del CONSOLIDAR"
		]
	},
	{
		id: "disciple",
		title: "Discipular",
		description: "",
		items: [
			"Pasión por los alumnos de capacitación destino",
			"Que podamos cumplir los propósitos de capacitación destino",
			"Unción, protección e inspiración para el equipo del departamento del DISCIPULADO"
		]
	},
	{
		id: "send",
		title: "Enviar",
		description: "",
		items: [
			"Que Dios levante nuevos líderes de célula y se abrán mas hogares.",
			"Que Dios nos inspire a estructurar y administrar el crecimiento de iglesia norte internacional.",
			"Unción, protección e inspiración para el equipo del departamento del ENVIAR."
		]
	},
	{
		id: "spain",
		title: "España",
		description: "",
		items: [
			"Por la salvación de España",
			"Orar por los Dirigentes del País.",
			"Orar por un despertar en las Iglesias de España."
		]
	},
	{
		id: "other",
		title: "Otros Ministerios",
		description: "",
		items: [
			"Pastores Jose Luis y Esra Barrios en Madrid",
			"Pastores Lennart y Carolina Torebring en Estocolmo",
			"Pastores César y Claudia Castellanos en Bogotá"
		]
	},
	{
		id: "israel",
		title: "Israel",
		description: "",
		items: [
			"Pedimos por la Paz de Jerusalem.",
			"Bendecimos el Gobierno y la Economía de Israel.",
			"Oramos por el Cuerpo de Cristo en Israel y sus Pastores"
		]
	},
]


import Guide from '../routes/guide';
import List from '../routes/list';
import Schedule from '../routes/schedule';

import Navigation from './navigation';

export default class App extends Component {
	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = (e) => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Helmet
					link={[
						{"rel": "apple-touch-icon", "sizes": "180x180", "href": "/assets/icons/apple-touch-icon.png"},
						{"rel": "mask-icon", "href": "/assets/icons/safari-pinned-tab.svg", "color": "#5bbad5"}
					]}/>
				<div class="wrapper">
					<Router onChange={this.handleRoute}>
						<Schedule path="/" data={listData} />
						<List path="/list/" data={listData} />
						<Guide path="/guide/" />
					</Router>
				</div>

				<Navigation />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js